"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAnalyticsClient = exports.analyticsEventAttribute = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
const anonymousUserTracker_1 = require("./anonymousUserTracker");
const EventContext_1 = require("../model/EventContext");
const checkForcefullyDisabled_1 = require("./checkForcefullyDisabled");
exports.analyticsEventAttribute = 'data-analytics-event';
class AppAnalyticsClient {
    constructor(params) {
        this.isInitialized = false;
        this.context = new EventContext_1.EventContext({});
        this.setContext = (context) => {
            this.context = context;
            browser_rum_1.datadogRum.setGlobalContext;
        };
        const isForcefullyDisabled = (0, checkForcefullyDisabled_1.checkForcefullyDisabled)();
        this.disabled = isForcefullyDisabled || (params.disabled || false);
        if (this.disabled) {
            return;
        }
        this.isInitialized = Boolean(browser_rum_1.datadogRum.getInitConfiguration());
        if (this.isInitialized) {
            return;
        }
        if (!params.datadogApplicationId || !params.datadogClientToken) {
            this.disabled = true;
            return;
        }
        browser_rum_1.datadogRum.init({
            applicationId: params.datadogApplicationId,
            clientToken: params.datadogClientToken,
            site: 'datadoghq.com',
            service: params.service,
            env: params.env,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 0,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            actionNameAttribute: exports.analyticsEventAttribute,
            proxy: `${params.appAnalyticsServiceUrl}/dd`,
        });
        this.isInitialized = true;
    }
    sendEvent(event) {
        if (this.disabled) {
            return;
        }
        const { eventType, ...rest } = event;
        browser_rum_1.datadogRum.addAction(eventType, rest);
        // Clear the .asString context property after sending the event
        browser_rum_1.datadogRum.setGlobalContextProperty('asString', undefined);
    }
    getContext() {
        return this.context;
    }
    setContextProperty(key, value) {
        this.context[key] = value;
        browser_rum_1.datadogRum.setGlobalContextProperty(key, value);
    }
    getContextProperty(key) {
        return this.context[key];
    }
    setUser(user, options) {
        if (options.isAnonymous) {
            (0, anonymousUserTracker_1.setAnonymousUserIdIfNotExists)();
        }
        const id = options.isAnonymous ? (0, anonymousUserTracker_1.getAnonymousUserId)() : user.userId;
        this.user = {
            ...user,
            userId: id,
            displayName: options.isAnonymous ? id : user.displayName,
        };
        browser_rum_1.datadogRum.setUser({
            id: this.user.userId,
            email: this.user.email,
            name: this.user.displayName,
        });
    }
    getUser() {
        return browser_rum_1.datadogRum.getUser();
    }
    setDisabled(disabled) {
        const isForcefullyDisabled = (0, checkForcefullyDisabled_1.checkForcefullyDisabled)();
        this.disabled = isForcefullyDisabled || disabled;
    }
    isDisabled() {
        return this.disabled;
    }
}
exports.AppAnalyticsClient = AppAnalyticsClient;
//# sourceMappingURL=AppAnalyticsClient.js.map